import styled from 'styled-components';

export const ErrorBadge = styled.span`
  background-color: ${(props) => props.theme.errorBadge};
  color: ${(props) => props.theme.white};
  border-radius: 50%;
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  margin-left: 8px;
`;
